<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1 i18n>Create new venue</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (easFormGroup$ | async; as group) {
      <form [formGroup]="group.control">
        <div class="form-container">
          <eas-easform-group [easGroup]="group">
          </eas-easform-group>
        </div>
      </form>
    } @else {
      @if (!error) {
        <div i18n>Loading ...</div>
      }
      @if (error) {
        <div>{{ error }}</div>
      }
    }
  </mat-card-content>
  <mat-card-actions align="start">
    <button mat-flat-button color="primary" type="submit" (click)="onSubmit()" i18n>Submit</button>
  </mat-card-actions>
</mat-card>